module.exports = __webpack_public_path__ + "img/1549050356.a5d9f014.jpg";